import { BULLETINS, NOTIFICATIONS } from '../../utils/constants';
import requestService from '../../services/request';
export default {
  state: {
    items: [],
    pdfPages: {},
    loading: false,
    error: false,
  },
  getters: {
    [BULLETINS.HAS_BULLETINS]: (state) => state.items.length > 0,
    [BULLETINS.GET_BULLETINS]: (state) => state.items,
    [BULLETINS.GET_PDF_PAGES]: (state) => state.pdfPages,
    [BULLETINS.IS_LOADING]: (state) => state.loading,
    [BULLETINS.HAS_ERROR]: (state) => state.error,
  },
  mutations: {
    [BULLETINS.SET_BULLETINS]: (state, payload) => {
      state.items = payload;
    },
    [BULLETINS.CHANGE_PAGE]: (state, { id, operator }) => {
      // pages are index 1 based
      switch (operator) {
        case '+':
          if (state.pdfPages[id].currentPage < state.pdfPages[id].pagesTotal)
            state.pdfPages[id].currentPage++;
          break;
        case '-':
          if (state.pdfPages[id].currentPage > 1)
            state.pdfPages[id].currentPage--;
          break;
      }
    },
  },
  actions: {
    [BULLETINS.FETCH_BULLETINS]: async (
      { commit, state },
      params,
      unitObj = null
    ) => {
      if (state.loading) return;
      try {
        state.loading = true;
        state.error = false;
        const url = `${process.env.GET_BY_ENTERPRISE}/bulletin`;
        const result = await requestService(url, 'GET', {
          params,
          localErrorHandling: true,
          auth: true,
          customHeaders: null,
          useLoading: false,
        });

        if (result) {
          const items = result.sort((a, b) =>
            a.lastModified > b.lastModified ? -1 : 1
          );
          commit(NOTIFICATIONS.MUTATE_BULLETINS, [...items]);
          state.items = items;
          for (const item of items) {
            if (!state.pdfPages[item._id]) {
              state.pdfPages[item._id] = {
                currentPage: 1,
                pagesTotal: null,
              };
            }
          }
        }
      } catch (err) {
        state.error = true;
      } finally {
        state.loading = false;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/bulletins.js